import {memo} from 'react';

import {useStateFromUrl} from '@macmillanplatform/ui-core/hooks';

import {clearSelectedOrder, getSelectedOrder} from './helpers/selected-order';
import {browserHistory} from '@/shared/utils';

import OrderDetails from './components/order-details';
import Orders from './components/orders';

import './index.css';

const HomePage = () => {
  const [{poNumber, orderDate}] = useStateFromUrl(
    getSelectedOrder,
    browserHistory
  );

  return (
    <main className="Product__main Home">
      <Orders />
      {poNumber && orderDate && (
        <OrderDetails
          poNumber={poNumber}
          orderDate={orderDate}
          closeHandler={clearSelectedOrder}
        />
      )}
    </main>
  );
};

export default memo(HomePage);
